import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step__basic" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { for: "title" }
const _hoisted_4 = { style: {"margin-top":"-45px"} }
const _hoisted_5 = { for: "contents" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Адрес здания", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Российская Федерация, М.О., г. Подольск, деревня Борисовка (АЗС)", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Основные особенности и характеристики здания", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Пример: помещение расположено на первом этаже, тип здания - нежилое", -1)
const _hoisted_10 = { class: "right" }
const _hoisted_11 = { style: {"margin-top":"115px"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Характеристика средства размещения информации", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Пример: Вывеска со светодиодной подсветкой, Боковина ПВХ - 4 мм.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_switch = _resolveComponent("v-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", null, [
        _createElementVNode("label", _hoisted_3, [
          _createVNode(_component_v_switch, {
            style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
            color: "#2F80ED",
            modelValue: _ctx.document.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.document.title) = $event)),
            label: "Титульный лист (рекомендуется)"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _createVNode(_component_v_switch, {
            style: {"display":"flex","flex-direction":"row","justify-content":"flex-start"},
            color: "#2F80ED",
            modelValue: _ctx.document.contents,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.document.contents) = $event)),
            label: "Оглавление (рекомендуется)"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_6,
        _hoisted_7,
        _withDirectives(_createElementVNode("textarea", {
          class: "input",
          type: "text",
          placeholder: "Введите адрес здания",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.document.address) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.address]
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_8,
        _hoisted_9,
        _withDirectives(_createElementVNode("textarea", {
          class: "input",
          type: "text",
          placeholder: "Введите особенности и характеристики здания",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.document.characteristics_building) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.characteristics_building]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _hoisted_13,
        _withDirectives(_createElementVNode("textarea", {
          style: {"height":"171px"},
          class: "input",
          type: "text",
          placeholder: "Введите характеристику средств размещения информации",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.document.characteristics_info) = $event))
        }, null, 512), [
          [_vModelText, _ctx.document.characteristics_info]
        ])
      ])
    ])
  ]))
}